import React, { ReactNode } from "react";
import UnauthorizedPage from "@/pages/Unauthorized/unauthorized-page";
import { useSession } from "@/common/providers/session-provider";

interface PermissionGateProps {
  /** Access is granted when the user has at least one of these permissions. */
  anyOfPermissions: string[];
  children: ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({ anyOfPermissions, children }) => {
  const { hasPermission } = useSession();
  const isAuthorized = anyOfPermissions.some(hasPermission);

  if (!isAuthorized) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};
